export default "__VITE_ASSET__B8qWNgS3__"